import { useRef } from 'react';

const serialize = (value: unknown) =>
  JSON.stringify(value ?? null, (_key, entry) =>
    typeof File !== 'undefined' && entry instanceof File ? `${entry.name}:${entry.size}` : entry,
  );

export function useContentStableValue<T>(value: T): T {
  const stableRef = useRef({ value, key: serialize(value) });
  const key = serialize(value);
  if (key !== stableRef.current.key) stableRef.current = { value, key };
  return stableRef.current.value;
}
